/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import { Box, Center, SimpleGrid, Text } from '@chakra-ui/react';
import Header, { HeaderDescription, HeaderTitle } from '../../shared/components/Header';
import BannerItem from './components/BannerItem';
import useStore from '../../shared/store';
import { PageSpinner } from '../../shared/styles';

function Banners() {
  const { fetchBanners } = useStore((state) => state.api);
  const { data, isLoading } = useStore((state) => state.banners.fetchBanners);
  const banners = data.data.banners ?? [];

  const loadingView = (
    <Center>
      <PageSpinner marginBottom="5" />
    </Center>
  );

  const bannersList = (
    <SimpleGrid columns={{ md: 2, lg: 2, xl: 3, '2xl': 4 }} minChildWidth="300px" spacing="50px">
      {banners.map((item) => (
        <BannerItem key={item.id} item={item} />
      ))}
    </SimpleGrid>
  );
  useEffect(() => {
    fetchBanners();
  }, [fetchBanners]);

  return (
    <Box padding="40px 30px 0 45px">
      <Header marginBottom="20px">
        <HeaderTitle icon="icon-list">
          Gestão de Categorias
          <HeaderDescription>Insira midias para as categorias do app Marisa</HeaderDescription>
        </HeaderTitle>
      </Header>

      {isLoading ? loadingView : bannersList}
    </Box>
  );
}

export default Banners;
